import React, { useState } from "react";
import "../style/shared/SideNavbar.css";

const SideNavbar = ({ toggleMenu, handleMenuClick, className, menuItems, activeItem }) => {
  const handleMenuSelection = (menuName) => {
    handleMenuClick(menuName); // Call the parent's handler
    // On mobile, close the menu after selection
    if (className.includes("active")) {
      toggleMenu();
    }
  };

  const navigationClass = `navigation ${className}`;
  const isMenuActive = className.includes("active");

  return (
    <>
      {/* Click-outside overlay for mobile */}
      <div 
        className={`sidebar-overlay ${isMenuActive ? "active" : ""}`} 
        onClick={toggleMenu}
      ></div>
      
      <div className={navigationClass} id="navigation">
        <ul>
          <li>
            <b>
              <span className="icon">
                <i className="fa-solid fa-house-chimney" aria-hidden="true"></i>
              </span>
              <span className="title">HomeBox</span>
            </b>
            <div className="mobile-close-btn" onClick={toggleMenu}>
              <i className="fa-solid fa-xmark"></i>
            </div>
          </li>
          {/* Dynamic Menu Rendering */}
          {menuItems && menuItems.map((item) => (
            <li key={item.key}>
              <b
                className={activeItem === item.key ? "active" : ""}
                onClick={() => handleMenuSelection(item.key)}
              >
                <span className="icon">
                  <i className={item.icon} aria-hidden="true"></i>
                </span>
                <span className="title">{item.title}</span>
              </b>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default SideNavbar;
